// extracted by css-extract-rspack-plugin
module.exports =  {"variant":"ProductVariant-r3vo__variant"};